import { styled } from "styled-components";

const StyledSpan = styled.span`
  display: inline-block;
  position: relative;
  top: 3px;
  margin-left: 4px;
  margin-right: 4px;
`;

export { StyledSpan };
